export const en = {
  'ad.label': 'Advertisement',
  'ad.sponsored_by': 'Sponsored by {advertiser}',
  'ad.visit': 'Visit',
  'cookies.preferences': 'Cookie preferences',
  'cookies.title': 'Your privacy, under your control',
  'cookies.description': 'We use necessary storage so Albambam can work. We only enable analytics or marketing with your permission. You can withdraw it at any time. Read the',
  'cookies.privacy_link': 'Privacy Policy',
  'cookies.close': 'Close preferences',
  'cookies.necessary': 'Necessary',
  'cookies.necessary_desc': 'Session, security, language and basic preferences.',
  'cookies.analytics': 'Analytics',
  'cookies.analytics_desc': 'Anonymous usage measurement to improve the service.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Advertising personalization and campaign measurement.',
  'cookies.configure': 'Configure',
  'cookies.reject': 'Reject optional',
  'cookies.save': 'Save selection',
  'cookies.accept': 'Accept all',
  'lang.selector_label': 'Language',
  'lang.changed': 'Language changed',
  'nav.home': 'Home',
  'nav.categories': 'Categories',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Friendship',
  'nav.upload': 'Upload',
  'nav.profile': 'Profile',
  'nav.login': 'Log in',
  'common.signed_in': 'Signed in',
  'common.error': 'Error',
  'topbar.search_placeholder': 'Search videos, creators...',
  'legal.terms': 'Terms',
  'legal.privacy': 'Privacy',
  'nav.admin': 'Admin',
  'nav.logout': 'Log out',
  'admin.tab.payments': 'Payments',
  'admin.payments.title': 'Payments',
  'cats.title': 'Categories',
  'cats.all': 'All',
  'cats.adult_title': '18+ categories',
  'cats.empty': 'No videos in this category.',
  'friends.block_confirm': 'Block this friend? You will no longer be able to chat or see each other as friends.',
  'friends.accepted': 'You are now friends!',
  'friends.title': 'Friendship',
  'friends.subtitle': 'Only people who follow each other mutually become friends and can chat privately.',
  'friends.unread_count_label': '{n} messages to read',
  'friends.blocked_users_title': 'Blocked users',
  'friends.unblock_user': 'Unblock',
  'friends.requests_title': 'Chat requests',
  'friends.request_badge': 'Request',
  'friends.request_accept': 'Accept',
  'friends.request_ignore': 'Ignore',
  'friends.empty_title': 'No friends yet',
  'friends.empty_subtitle': 'Follow someone and get followed back to unlock private chat.',
  'friends.attach_image': 'Photo',
  'friends.shared_video_label': 'Shared a video',
  'friends.select_conversation': 'Select a friend to start chatting',
  'friends.block_user': 'Block',
  'friends.no_messages_yet': 'No messages yet. Say hi!',
  'friends.message_placeholder': 'Write a message...',
  'section.trending': 'Trending',
  'section.shorts': 'Shorts',
  'section.for_you': 'For you',
  'home.hero.badge': 'Welcome to Albambam',
  'home.hero.title_1': 'Short videos.',
  'home.hero.title_2': 'Real creators.',
  'home.hero.subtitle': 'Watch, share and earn. Upload your videos and discover new talents in every category.',
  'home.hero.cta_shorts': 'Watch Shorts',
  'home.hero.cta_trending': 'Trending',
  'home.shorts.see_all': 'See all',
  'home.empty.title': 'No videos yet',
  'home.empty.subtitle': 'When creators upload content, it will appear here.',
  'live.send_diamonds': 'Send diamonds',
  'live.buy': 'Buy',
  'live.chat': 'Chat',
  'live.type_message': 'Type a message...',
  'live.send': 'Send',
  'auth.success_google': 'Signed in with Google',
  'auth.fail_google': 'Invalid Google session',
  'auth.success_login': 'Signed in',
  'auth.success_register': 'Account created',
  'auth.login_tab': 'Log in',
  'auth.register_tab': 'Create account',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.submit_login_loading': 'Logging in...',
  'auth.submit_login': 'Log in',
  'auth.name': 'Name',
  'auth.submit_register_loading': 'Creating...',
  'auth.submit_register': 'Create account',
  'auth.or': 'or',
  'legal.privacy_title': 'Privacy Policy',
  'search.title': 'Results for \\u201c{q}\\u201d',
  'search.count': '{n} videos',
  'search.empty': 'No results.',
  'series.load_error': 'The series could not be loaded',
  'series.unlocked': 'Series unlocked',
  'series.purchase_error': 'The purchase could not be started',
  'series.restricted': 'Restricted access',
  'series.configure_access': 'Configure access',
  'series.language_all': 'All languages',
  'series.episode_count': '{n} episodes',
  'series.buy': 'Buy series',
  'series.filter_language': 'Filter by language',
  'series.no_episodes': 'No episodes have been published yet.',
  'series.episode_number': 'Episode {n}',
  'legal.terms_title': 'Terms and Conditions',
  'lang.ca': 'Catalan',
  'lang.en': 'English',
  'lang.es': 'Spanish',
  'lang.fr': 'French',
  'lang.de': 'German',
  'lang.it': 'Italian',
  'lang.eu': 'Basque',
  'lang.gl': 'Galician',
  'lang.zh': 'Chinese',
  'lang.other': 'Other',
  'lang.vi': 'Vietnamese',
  'lang.ja': 'Japanese',
  'lang.ko': 'Korean',
  'lang.ru': 'Russian',
  'lang.ro': 'Romanian',
  'lang.ar': 'Arabic',
  'lang.tr': 'Turkish',
  'lang.pl': 'Polish',
  'lang.ms': 'Malay',
  'lang.ta': 'Tamil',
  'upload.series_title_error': 'Enter the series title',
  'upload.series_adult_category_error': 'Select an 18+ category for the series',
  'upload.series_created': 'Series created',
  'upload.series_create_error': 'The series could not be created',
  'upload.err_file': 'Choose a valid video file',
  'upload.err_title': 'Set a title',
  'upload.series_select_error': 'Select or create a series',
  'upload.trailer_target_error': 'Select the trailer video or series',
  'upload.price_error': 'Enter a valid price of at least EUR 0.50.',
  'upload.adult_category_error': 'Select an adult category',
  'upload.success': 'Video uploaded',
  'upload.title_h': 'Upload a video',
  'upload.kind': 'Post type',
  'upload.kind_video': 'Standalone video',
  'upload.kind_episode': 'Series episode',
  'upload.kind_trailer': 'Public Shorts trailer',
  'upload.series': 'Series',
  'upload.series_select': 'Select a series',
  'upload.episode': 'Episode',
  'upload.series_new_title': 'New series title',
  'upload.series_create': 'Create series',
  'upload.series_adult': '18+ series',
  'upload.series_premium': 'Premium series',
  'upload.series_adult_category': 'Series 18+ category',
  'upload.series_price': 'Episode and bundle price (EUR)',
  'upload.trailer_for': 'The trailer presents',
  'upload.trailer_select': 'Select a video or series',
  'upload.video_prefix': 'Video',
  'upload.file_label': 'Video file (MP4, max 1GB)',
  'upload.file_pick': 'Click to choose a video',
  'upload.thumb_label': 'Thumbnail (optional)',
  'upload.video_title': 'Title',
  'upload.description': 'Description',
  'upload.category': 'Category',
  'upload.is_short': 'Is a Short (vertical)',
  'upload.paid_video': 'Paid video',
  'upload.adult_content': '18+ content',
  'upload.video_language': 'Video language',
  'upload.individual_price': 'Price to watch this video (EUR)',
  'upload.paid_video_help': 'The viewer buys permanent access to this video only. The minimum price is EUR 0.50.',
  'upload.adult_category': 'Adult category',
  'upload.uploading': 'Uploading {n}%',
  'upload.submit': 'Upload video',
  'user.followers': 'followers',
  'user.following': 'following',
  'user.follow': 'Follow',
  'user.chat_open': 'Chat',
  'user.request_sent': 'Request sent',
  'user.send_message': 'Send message',
  'user.followers_title': 'Followers',
  'user.following_title': 'Following',
  'user.unfollow': 'Unfollow',
  'user.request_title': 'Chat request',
  'user.request_subtitle': 'You can only send one message. If they accept your request, you will become friends and can chat.',
  'user.request_placeholder': 'Write your message...',
  'user.request_send': 'Send request',
  'shorts.login_for_like': 'Sign in to like',
  'watch.share_copied': 'Link copied',
  'watch.delete_confirm': 'Delete this comment?',
  'ad.skip_in': 'Skip in {n}s',
  'ad.skip': 'Skip ad',
  'watch.share': 'Share',
  'friends.share_video': 'Share a video',
  'friends.send': 'Send',
  'watch.comments': 'Comments',
  'watch.write_comment': 'Write a comment...',
  'watch.publish': 'Publish',
  'watch.login_to_comment': 'Sign in to comment.',
  'watch.login_btn': 'Sign in to comment',
  'watch.no_comments': 'No comments yet.',
  'watch.related': 'Related',
  'nav.trending': 'Trending',
  'friends.follow_option_only_follow': 'Follow',
  'friends.follow_option_friends': 'Friends',
  'watch.like': 'Like',
  'watch.views_short': '{n} views',
  'shorts.empty.title': 'No Shorts yet',
  'shorts.empty.subtitle': 'Upload a short video to start the section.',
  'shorts.share': 'Share',
  'auth.continue_google': 'Continue with Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Price (€)',
  'upload.err_select': 'Choose a video',
  'profile.upload_btn': 'Upload video',
  'profile.tab_videos': 'My videos ({n})',
  'profile.tab_history': 'History',
  'profile.tab_recos': 'Recommendations',
  'profile.no_videos': 'You haven\'t uploaded any videos yet.',
  'profile.no_history': 'You haven\'t watched any videos yet.',
  'profile.no_recos': 'Watch some videos to receive recommendations.',
  'profile.likes': 'likes',
  'profile.views': 'views',
  'wallet.title': 'Wallet',
  'wallet.rate_label': 'Rate',
  'wallet.min_label': 'Min withdrawal',
  'wallet.amount_label': 'Amount to withdraw',
  'wallet.withdraw_btn': 'Request withdrawal',
  'wallet.history_title': 'Withdrawal history',
  'wallet.success': 'Request created',
  'wallet.bad_amount': 'Invalid amount',
  'wallet.per_view': '{rate} {cur}/view',
  'admin.title': 'Admin',
  'admin.stats.users': 'Users',
  'admin.stats.videos': 'Videos',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Views',
  'admin.tab.videos': 'Videos',
  'admin.tab.ads': 'Ads',
  'admin.tab.users': 'Users',
  'admin.tab.withdrawals': 'Withdrawals',
  'admin.tab.config': 'Settings',
  'admin.tab.translations': 'Translations',
  'tbl.title': 'Title',
  'tbl.creator': 'Creator',
  'tbl.category': 'Category',
  'tbl.type': 'Type',
  'tbl.views': 'Views',
  'tbl.likes': 'Likes',
  'tbl.status': 'Status',
  'tbl.actions': 'Actions',
  'tbl.placement': 'Placement',
  'tbl.advertiser': 'Advertiser',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Clicks',
  'tbl.active': 'Active',
  'tbl.name': 'Name',
  'tbl.email': 'Email',
  'tbl.role': 'Role',
  'tbl.wallet': 'Wallet',
  'tbl.amount': 'Amount',
  'tbl.date': 'Date',
  'tbl.user': 'User',
  'video.video': 'Video',
  'video.short': 'Short',
  'action.show': 'Publish',
  'action.hide': 'Hide',
  'action.delete_confirm_video': 'Delete video?',
  'ad.create_h': 'Create ad',
  'ad.title_label': 'Title',
  'ad.image_label': 'Image URL',
  'ad.target_label': 'Target URL',
  'ad.advertiser_label': 'Advertiser',
  'ad.placement_label': 'Placement',
  'ad.placement.banner': 'Banner (site)',
  'ad.placement.preroll': 'Pre-roll (before video)',
  'ad.placement.overlay': 'Overlay (inside video)',
  'ad.active': 'Active',
  'ad.create_btn': 'Create',
  'ad.success_create': 'Ad created',
  'ad.delete_confirm': 'Delete ad?',
  'users.make_admin': 'Make admin',
  'users.remove_admin': 'Remove admin',
  'wd.approve': 'Approve',
  'wd.reject': 'Reject',
  'wd.mark_paid': 'Mark paid',
  'wd.empty': 'No requests',
  'cfg.title': 'Payment settings',
  'cfg.rate_label': 'Payment per view ({cur})',
  'cfg.min_label': 'Minimum withdrawal ({cur})',
  'cfg.currency': 'Currency',
  'cfg.save': 'Save',
  'cfg.saved': 'Settings saved',
  'trans.title': 'Languages & translations',
  'trans.intro': 'Upload a JSON file with translations for any language code (e.g. ja, pt, zh). The file must contain a flat map of key → string.',
  'trans.code_label': 'Language code (e.g. ja, pt-BR, zh)',
  'trans.name_label': 'Display name (in that language)',
  'trans.file_label': 'Translations JSON file',
  'trans.upload': 'Upload',
  'trans.uploaded': 'Translations saved',
  'trans.delete': 'Delete',
  'trans.delete_confirm': 'Delete this language?',
  'trans.builtin': 'Built-in',
  'trans.custom': 'Custom',
  'trans.empty_custom': 'No custom languages yet.',
  'common.cancel': 'Cancel',
  'common.loading': 'Loading...',
  'common.too_fast': 'Too fast, please wait',
  'time.few_seconds': 'a few seconds ago',
  'time.min': '{n} min ago',
  'time.h': '{n} h ago',
  'time.d': '{n} d ago',
  'time.w': '{n} w ago',
  'time.mo': '{n} mo ago',
  'time.y': '{n} y ago',
  'brand.tagline': 'Short videos. Real creators.',
  'live.section': 'Live',
  'live.start': 'Start live',
  'live.end': 'End live',
  'live.join': 'Join live',
  'live.chat_placeholder': 'Type a message...',
  'live.diamond': 'Diamond',
  'live.buy_access': 'Buy access',
  'live.save_recording': 'Save recording',
};
